/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const BackIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <path
        d="M11.4975 5.99921L3.9075 5.99921L7.2075 2.70921C7.3958 2.52091 7.50159 2.26551 7.50159 1.99921C7.50159 1.73291 7.3958 1.47751 7.2075 1.28921C7.0192 1.10091 6.7638 0.995117 6.4975 0.995117C6.2312 0.995117 5.9758 1.10091 5.7875 1.28921L0.787498 6.28921C0.696458 6.38431 0.625093 6.49646 0.577498 6.61921C0.47748 6.86267 0.47748 7.13575 0.577498 7.37921C0.625093 7.50196 0.696458 7.61411 0.787498 7.70921L5.7875 12.7092C5.88046 12.8029 5.99106 12.8773 6.11292 12.9281C6.23478 12.9789 6.36549 13.005 6.4975 13.005C6.62951 13.005 6.76022 12.9789 6.88208 12.9281C7.00393 12.8773 7.11454 12.8029 7.2075 12.7092C7.30123 12.6162 7.37562 12.5056 7.42639 12.3838C7.47716 12.2619 7.5033 12.1312 7.5033 11.9992C7.5033 11.8672 7.47716 11.7365 7.42639 11.6146C7.37562 11.4928 7.30123 11.3822 7.2075 11.2892L3.9075 7.99921L11.4975 7.99921C11.7627 7.99921 12.0171 7.89385 12.2046 7.70632C12.3921 7.51878 12.4975 7.26443 12.4975 6.99921C12.4975 6.73399 12.3921 6.47964 12.2046 6.2921C12.0171 6.10457 11.7627 5.99921 11.4975 5.99921Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
